// extracted by mini-css-extract-plugin
export default {"root":"PlasmicAddClientButton_root__Lzojm","text___7UNfx":"PlasmicAddClientButton_text___7UNfx__JBQsM","text__smrlC":"PlasmicAddClientButton_text__smrlC__TH+3H"};